export enum EducationalUnitType {
  District = 'District',
  School = 'School',
}
